import React from 'react';

// Component for the "Mint Pixels" page with terms and conditions
function MintPixelsPage() {
  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '20px',
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      border: '1px solid #e0e0e0'
    }}>
      <h2 style={{ 
        color: '#2E7D32', 
        marginBottom: '20px',
        fontSize: '28px',
        fontWeight: '600',
        textAlign: 'center'
      }}>
        Mint Pixels on the Billion Dollar Site
      </h2>
      
      <div style={{
        padding: '10px',
        backgroundColor: '#f0f9ff',
        borderRadius: '8px',
        marginBottom: '25px',
        border: '1px solid #bae6fd'
      }}>
        <p style={{ margin: 0, lineHeight: '1.6', color: '#0369a1' }}>
        Welcome! Own a piece of <strong>digital history</strong> by purchasing pixel blocks as NFTs on the Ethereum blockchain.
        </p>
      </div>

      <div style={{
        padding: '10px',
        backgroundColor: '#f0f9ff',
        borderRadius: '8px',
        marginBottom: '25px',
        border: '1px solid #bae6fd'
      }}>
        <p style={{ margin: 0, lineHeight: '1.6', color: '#0369a1' }}>
        The Billion Dollar Site offers pixel blocks in various sizes, 
        each minted as a <strong>permanent NFT on the Ethereum blockchain.</strong> Your pixels become a lasting digital asset that <strong>you truly own,
        can trade, and will remain on the blockchain forever.</strong>
        </p>
      </div>

      <h3 style={{ 
        color: '#2E7D32', 
        margin: '30px 0 20px',
        fontSize: '22px',
        fontWeight: '600'
      }}>
        Available Pixel Sizes & Current Pricing
      </h3>
      
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: '16px',
        marginBottom: '25px'
      }}>
        <div style={{ 
          textAlign: 'center',
          padding: '20px 15px',
          border: '2px solid #e0e0e0',
          borderRadius: '12px',
          backgroundColor: '#fafafa',
          transition: 'all 0.2s ease',
          cursor: 'default'
        }}>
          <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#1976d2' }}>1×1</div>
          <div style={{ margin: '8px 0', color: '#666', fontSize: '14px' }}>100 Pixels</div>
          <div style={{ color: '#2E7D32', fontWeight: 'bold', fontSize: '16px' }}>0.25 ETH</div>
        </div>
        
        <div style={{ 
          textAlign: 'center',
          padding: '20px 15px',
          border: '2px solid #e0e0e0',
          borderRadius: '12px',
          backgroundColor: '#fafafa',
          transition: 'all 0.2s ease',
          cursor: 'default'
        }}>
          <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#1976d2' }}>2×2</div>
          <div style={{ margin: '8px 0', color: '#666', fontSize: '14px' }}>400 Pixels</div>
          <div style={{ color: '#2E7D32', fontWeight: 'bold', fontSize: '16px' }}>1.0 ETH</div>
        </div>
        
        <div style={{ 
          textAlign: 'center',
          padding: '20px 15px',
          border: '2px solid #e0e0e0',
          borderRadius: '12px',
          backgroundColor: '#fafafa',
          transition: 'all 0.2s ease',
          cursor: 'default'
        }}>
          <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#1976d2' }}>5×5</div>
          <div style={{ margin: '8px 0', color: '#666', fontSize: '14px' }}>2,500 Pixels</div>
          <div style={{ color: '#2E7D32', fontWeight: 'bold', fontSize: '16px' }}>6.25 ETH</div>
        </div>
        
        <div style={{ 
          textAlign: 'center',
          padding: '20px 15px',
          border: '2px solid #e0e0e0',
          borderRadius: '12px',
          backgroundColor: '#fafafa',
          transition: 'all 0.2s ease',
          cursor: 'default'
        }}>
          <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#1976d2' }}>10×10</div>
          <div style={{ margin: '8px 0', color: '#666', fontSize: '14px' }}>10,000 Pixels</div>
          <div style={{ color: '#2E7D32', fontWeight: 'bold', fontSize: '16px' }}>25 ETH</div>
        </div>
      </div>
      
      <div style={{
        padding: '16px',
        backgroundColor: '#f3e5f5',
        borderRadius: '8px',
        marginBottom: '25px',
        border: '1px solid #ce93d8'
      }}>
        <p style={{ margin: 0, lineHeight: '1.6', fontSize: '15px' }}>
          <strong>💡</strong> Each block represents a 10×10 pixel area (100 pixels total) to make your content clearly visible on the grid. 
          With each pixel priced at 0.0025 ETH, every block purchase gives you substantial, visible space on the blockchain!
        </p>
      </div>
      
      <h3 style={{ 
        color: '#2E7D32', 
        margin: '35px 0 20px',
        fontSize: '22px',
        fontWeight: '600'
      }}>
        How the Process Works
      </h3>
      
      <div style={{
        display: 'grid',
        gap: '16px',
        marginBottom: '30px'
      }}>
        <div style={{
 display: 'grid',
 gap: '18px',
 marginBottom: '30px'
}}>
 {[
   { 
     step: '1', 
     title: 'Connect Wallet', 
     desc: 'Link your Ethereum wallet (MetaMask recommended) to get started',
     details: [
       'Ensure sufficient ETH for pixel purchase and gas fees',
       'Switch to Ethereum Mainnet if needed',
       'Any Ethereum-compatible wallet works'
     ]
   },
   { 
     step: '2', 
     title: 'Choose Size & Position', 
     desc: 'Select your preferred pixel block size and click on the grid to choose location',
     details: [
       'Larger blocks get better visibility but cost more ETH',
       'Blue areas show selection, orange areas are blocked for approval, red areas indicate conflicts',
       'Check status panel above grid to confirm valid selection'
     ]
   },
   { 
     step: '3', 
     title: 'Submit Content', 
     desc: 'Provide your image URL, website link, and description (all fields required)',
     details: [
       'Image: Direct JPG/PNG links only, must be downloadable',
       'Transparent images display with white background',
       'Website: All websites are allowed, provided they comply with the terms and conditions.',
       'Description: Maximum 100 characters, stored in NFT metadata'
     ]
   },
   { 
     step: '4', 
     title: 'Approval Process', 
     desc: 'Your submission is reviewed for compliance (typically 24-48 hours)',
     details: [
       'Content reviewed for community standards compliance',
       'Rejected submissions receive automatic refunds (minus gas)',
       'Resubmit with different content if rejected',
       'We will not inform you of the reason for rejection',
       'Track status through your connected wallet'
     ]
   },
   { 
     step: '5', 
     title: 'NFT Minted', 
     desc: 'Once approved, your NFT is automatically minted and appears on the grid',
     details: [
       'The image is uploaded to Arweave for long-term storage.',
       'NFT becomes tradeable on all major marketplaces',
       'Content becomes permanently immutable once minted'
     ]
   }
 ].map((item, index) => (
   <div key={index} style={{
     border: '1px solid #e1e5e9',
     borderRadius: '8px',
     overflow: 'hidden',
     backgroundColor: '#ffffff'
   }}>
     {/* Header */}
     <div style={{
       display: 'flex',
       gap: '16px',
       padding: '18px',
       backgroundColor: '#f8f9fa',
       borderBottom: '1px solid #e1e5e9'
     }}>
       <div style={{
         minWidth: '36px',
         height: '36px',
         borderRadius: '50%',
         backgroundColor: '#2E7D32',
         color: 'white',
         display: 'flex',
         alignItems: 'center',
         justifyContent: 'center',
         fontWeight: '600',
         fontSize: '16px'
       }}>
         {item.step}
       </div>
       <div style={{ flex: 1 }}>
         <div style={{ fontWeight: '600', marginBottom: '4px', color: '#1a1a1a', fontSize: '16px' }}>
           {item.title}
         </div>
         <div style={{ color: '#666', fontSize: '14px', lineHeight: '1.5' }}>
           {item.desc}
         </div>
       </div>
     </div>
     
     {/* Details */}
     <div style={{ padding: '16px 18px' }}>
       {item.details.map((detail, detailIndex) => (
         <div key={detailIndex} style={{
           display: 'flex',
           gap: '12px',
           marginBottom: detailIndex < item.details.length - 1 ? '8px' : '0',
           fontSize: '13px',
           lineHeight: '1.5'
         }}>
           <span style={{ 
             color: '#2E7D32', 
             fontWeight: '500', 
             minWidth: '6px',
             marginTop: '2px'
           }}>
             •
           </span>
           <span style={{ color: '#4a4a4a' }}>{detail}</span>
         </div>
       ))}
     </div>
   </div>
 ))}
</div>
      </div>
      
      <h3 style={{ 
        color: '#2E7D32', 
        margin: '35px 0 20px',
        fontSize: '22px',
        fontWeight: '600'
      }}>
        Terms and Conditions
      </h3>
      
      <div style={{
        backgroundColor: '#fff3cd',
        border: '1px solid #ffeaa7',
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '20px'
      }}>
        <p style={{ margin: 0, fontWeight: '600', color: '#856404' }}>
          💡Please read these terms carefully before purchasing.
        </p>
      </div>
      
      <div style={{ 
        display: 'grid',
        gap: '12px',
        marginBottom: '25px'
      }}>
        {[
          {
            category: "Ownership Rights",
            items: [
              "Your NFT grants you the right to display content in your designated grid space on the Ethereum blockchain",
              "You do not own any part of the website infrastructure, code, or the Billion Dollar Site brand",
              "Your NFT represents a digital collectible and display license, not intellectual property rights to the website",
              "There is not limit of how many spaced on the grid you can purchase",
              "You can purchase multiple pixel blocks and combine them for larger displays",

            ]
          },
          {
            category: "Content & Approval",
            items: [
              "All submissions require approval - content must comply with the terms and conditins",
              "The project team reserves the right to reject any submission that does not meet these standards",
              "No offensive, illegal, adult, or inappropriate content will be accepted",
              "Content must be suitable for all audiences - no hate speech, violence, or illegal activities",
              "Image URLs must be publicly accessible and in common web formats (JPG, PNG, GIF, SVG)",
              "Website URLs must begin with 'http://' or 'https://' and link to legitimate websites",
              "You must have legal rights to use any submitted images and content",
              "Content must be suitable for all audiences - no hate speech, violence, or illegal activities",
              "You are responsible for ensuring your content complies with all applicable laws and regulations",
            ]
          },
          {
            category: "Transaction & Refund Policy",
            items: [
              "Payment reserves your pixel space during the approval process (typically 24-48 hours)",
              "If your submission is rejected, your payment is automatically refunded minus gas fees",
              "Once approved and minted, content becomes permanent and cannot be changed - no exceptions",
              "All transactions are final after successful minting - no refunds for approved content"
            ]
          },
          {
            category: "NFT Trading & Royalties",
            items: [
              "Your NFT can be sold or transferred on any compatible Ethereum NFT marketplace",
              "The project creator receives an 8% royalty on all secondary sales (ERC-2981 standard)",
              "You retain full ownership of your NFT and can trade it independently",
              "Original ownership history is permanently recorded on the blockchain",
            ]
          }
        ].map((section, sectionIndex) => (
          <div key={sectionIndex} style={{
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            overflow: 'hidden'
          }}>
            <div style={{
              backgroundColor: '#f5f5f5',
              padding: '12px 16px',
              fontWeight: '600',
              color: '#333',
              borderBottom: '1px solid #e0e0e0'
            }}>
              {section.category}
            </div>
            <div style={{ padding: '16px' }}>
              {section.items.map((item, itemIndex) => (
                <div key={itemIndex} style={{
                  display: 'flex',
                  gap: '10px',
                  marginBottom: itemIndex < section.items.length - 1 ? '10px' : '0',
                  fontSize: '14px',
                  lineHeight: '1.6'
                }}>
                  <span style={{ color: '#2E7D32', fontWeight: 'bold', minWidth: '16px' }}>•</span>
                  <span style={{ color: '#444' }}>{item}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      
      <div style={{
        padding: '20px',
        backgroundColor: '#e8f5e9',
        borderRadius: '12px',
        border: '2px solid #a5d6a7',
        textAlign: 'center'
      }}>
        <h4 style={{ 
          margin: '0 0 12px', 
          color: '#2E7D32',
          fontSize: '18px',
          fontWeight: '600'
        }}>
          🚀 Ready to Get Started?
        </h4>
        <p style={{ 
          margin: '0 0 16px',
          lineHeight: '1.6',
          color: '#1b5e20'
        }}>
          Head back to the <strong>Home</strong> page to connect your wallet and start selecting pixels. 
          Your piece of digital history awaits!
        </p>
        <div style={{
          fontSize: '14px',
          color: '#2e7d32',
          fontStyle: 'italic'
        }}>
          Current average approval time: 24-48 hours
        </div>
      </div>
    </div>
  );
}

export default MintPixelsPage;